// Decision pura: si corresponde aplicar el defaultvalue de un subcampo dinamico
// (dentro de un type48) en la materializacion actual.
//
// Extraida de CustomfieldsComponent.showDynamicFieldsInType48 para poder testear
// los escenarios de rebuild/navegacion sin instanciar el componente ni el form.

export interface ApplyDefaultDecisionInput {
  /** Valor ya resuelto para el control (tras preservar/normalizar). */
  finalValue: any;
  /** defaultvalue configurado en el subcampo (puede ser vacio/undefined). */
  defaultValue: any;
  /** Modo edicion sobre datos persistidos en backend. */
  isEdit: boolean;
  /** La fila fue reconstruida desde un snapshot preservado de navegacion. */
  rowWasPreserved: boolean;
  /** El FormControl esta pristine (no tocado en esta instancia). */
  controlPristine: boolean;
}

/**
 * True solo cuando el campo se materializa por PRIMERA vez y hay un defaultvalue
 * que aplicar. Se aplica el default unicamente si:
 *  - hay defaultvalue,
 *  - el valor resuelto quedo vacio,
 *  - NO estamos en edicion,
 *  - la fila NO viene de un snapshot preservado (fila nueva de verdad), y
 *  - el control esta pristine.
 *
 * Asi se evita reimponer el default sobre un vacio intencional del usuario tras
 * navegar el wizard (rebuild del form) y, a la vez, se sigue aplicando el default
 * en filas nuevas agregadas despues.
 */
export function shouldApplyDefaultValue(input: ApplyDefaultDecisionInput): boolean {
  const { finalValue, defaultValue, isEdit, rowWasPreserved, controlPristine } = input;
  // Solo '' / null / undefined cuentan como vacio. Un 0 o false son valores legitimos
  // y no deben ser pisados por el defaultvalue.
  const isEmpty = finalValue === '' || finalValue === null || finalValue === undefined;
  const hasDefault = defaultValue !== null && defaultValue !== undefined && defaultValue !== '';
  const isFreshMaterialization = !isEdit && !rowWasPreserved && controlPristine;
  return isEmpty && hasDefault && isFreshMaterialization;
}
